import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getAssessment() {
  try {
    const { data: response } = await axiosInstance({
      url: "/assessment",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLoginToken()}`,
      },
    });

    const questions = response?.data ?? [];

    const items = questions.map((question: any) => {
      const randomizedOptions = Array.isArray(question.options)
        ? [...question.options].sort(() => Math.random() - 0.5)
        : [];
      return {
        ...question,
        options: randomizedOptions,
      };
    });

    return items;
  } catch (error) {
    console.error("Error fetching assessment:", error);
    return [];
  }
}

const createAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: "/assessment",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: `/assessment/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: `/assessment/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useAssessment() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.assessment],
    queryFn: () => getAssessment(),
  });
  return data;
}

export function useCreateAssessment() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.assessment]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateAssessment() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.assessment]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteAssessment() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.assessment]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
